export const POLL_OFFER_MS = 4_000;
export const POLL_ORDER_SEARCHING_MS = 2_500;
export const POLL_ORDER_DEFAULT_MS = 15_000;
export const POLL_ORDER_BACKOFF_MS = 60_000;
export const POLL_ORDER_LOCATION_MS = 5_000;
